module.exports = __webpack_public_path__ + "static/pro-development-section-2-e1870cf12d74fa485649121cd1399c91.png";